export default "__VITE_ASSET__BcHbKXPp__"